import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/element.js'
import axios from 'axios'
import { mapState, mapMutations } from 'vuex';
import globalVariable from './components/config/globalVariable';
import EventBus from './eventBus/eventBus'
import MathJax  from '../Math.js'
 
import {
    post,
    get,
    link,
    addScript
} from "./utils/axios.js"

import Api from './utils/api.js'
Vue.prototype.$api = Api.Api

// 聊天组件
import chat from "@/components/chat.vue"
Vue.component('chat', chat)
Vue.prototype.MathJax =MathJax
Vue.prototype.$get = get;
Vue.prototype.$post = post;
Vue.prototype.$link = link;
Vue.prototype.$addScript = addScript;
Vue.prototype.szUrl = 'https://www.sz517.com/';
Vue.prototype.tkUrl = 'https://tk.sz517.com/';
Vue.prototype.user_id = localStorage.getItem("user_id") || '';
Vue.prototype.user_name = localStorage.getItem("user_name") || '';
Vue.prototype.user_image = localStorage.getItem("user_image") || '';
Vue.prototype.user_vip = localStorage.getItem("user_vip") || '';
// Vue.prototype.token = localStorage.getItem("token") || '';
Vue.prototype.commonsVariable = globalVariable;
Vue.prototype.$axios = axios
Vue.prototype.$store = store
Vue.config.productionTip = false

new Vue({
    router,
    store,
    created() {
        
        
        // this.$axios.defaults.baseURL = 'http://app.com/tk/';
        this.$axios.defaults.baseURL = 'https://api.sz517.com/tk/'
        // this.$axios.defaults.baseURL = 'http://my.api.com/tk/'
        var that = this

     
        router.beforeEach((to, from, next) => {

                
            if (to.matched.some(res => res.meta.requireAuth)) { // 验证是否需要登陆
                if (localStorage.getItem('UserToken') && localStorage.getItem('UserToken') !== '') { // 查询本地存储信息是否已经登陆
                    next();
                } else {
                    next({
                        path: '/index', // 未登录则跳转至404页面
                        query: {
                            _from: from.fullPath,
                            _to: to.fullPath
                        } // 登陆成功后回到当前页面，这里传值给login页面，to.fullPath为当前点击的页面
                    });
                }
            }


            else if ((from.path === '/answerPastReal' || from.path === '/answeRandom') && to.path !== '/results' && from.path !== '') {

                EventBus.$on('mianname',(num) => {
                    console.log(num)
                    console.log(new Date())
                    that.sunm = num
                })
                console.log(that.sunm)
                if (that.sunm !== undefined) {
                    that.sunm = undefined
                    console.log("重复")
                    next()

                }
                else {
                    console.log('elsesss')
                    that.$store.commit("getli", true)
                }



                // Vue.prototype.$confirm("您要结束本次练习吗？",  {
                //       confirmButtonText: "确定",
                //       cancelButtonText: "取消",
                //       type: "warning",
                //   })
                //   .then(() => {

                //         next()


                //   })
                //   .catch(() => {


                //   });

            }



            else {
                console.log('else')
                next();
            }

            // 

        })
        router.afterEach((to, from, next) => {
            console.log("跳转之后获取", to, from)
            window,
                scrollTo(0, 0)
        })

        // setTimeout(() => {
        //     localStorage.setItem("user_id", '');
        //     localStorage.setItem("user_name", '');
        //     localStorage.setItem("user_image", '');
        //     localStorage.setItem("user_vip", '');
        //     localStorage.removeItem("token");
        //     this.$router.push('/')
        //     this.$router.go(0)
        // }, 3600000);
    },
    render: h => h(App)
}).$mount('#app')